import { wfetch } from "../utils/fetch";
import { debounce } from "../utils/performance";
import { createElement, removeChildren, highlightSubtring } from "../utils/DOMutils";
import animateValue, { updateHeight } from "../utils/animateValue";
import { getSearchInputElements, handleSearchInput, handleSearchReset } from "../utils/searchInput";

export default function(el) {
    const resultsWrapperEl = el.querySelector(".ho__results-wrapper");
    const resultsListEl = el.querySelector(".ho__results-list");
    const [searchInput, inputEl, resetButtonEl] = getSearchInputElements(el);
    const restUrl = el.dataset.restUrl;
    let abortController = null;

    const state = {
        searchQuery: null,
        results: [],
    };

    const createResultEl = (name, link) => {
        const resultEl = createElement("li", { class: "ho__result" });
        const linkEl = createElement("a", { class: "ho__result-link", href: link });

        linkEl.innerHTML = name;
        resultEl.appendChild(linkEl);

        return resultEl;
    };

    const appendResults = () => {
        for (const result of state.results) {
            if (!result.name || !result.link) continue;

            const highlightedName = highlightSubtring(result.name, state.searchQuery, "ho__result-highlight");

            const resultEl = createResultEl(highlightedName, result.link);
            resultsListEl.appendChild(resultEl);
        }
    };

    const animateResultsWrapperElHeight = (actionType = "add") =>
        animateValue(
            resultsWrapperEl,
            updateHeight,
            resultsWrapperEl.offsetHeight,
            actionType === "remove" ? 0 : resultsWrapperEl.scrollHeight,
            300
        );

    const handleInput = debounce((e) => {
        state.searchQuery = e.target.value;

        abortController && abortController.abort();

        abortController = new AbortController();

        if (state.searchQuery.length < 3) return resetState();

        wfetch(`${restUrl}?inputQuery=${state.searchQuery}`, { signal: abortController.signal })
            .then((result) => {
                resetState();

                if (!Array.isArray(result.data) || result.data.length === 0) return;

                state.results = result.data;
                appendResults();
                animateResultsWrapperElHeight();
            })
            .catch((err) => {});
    }, 300);

    const resetState = () => {
        if (state.results.length === 0) return;

        state.results = [];
        removeChildren(resultsListEl);
        animateResultsWrapperElHeight("remove");
    };

    if (!inputEl || !resultsWrapperEl || !resultsListEl || !restUrl) return;

    inputEl.addEventListener("input", handleInput);

    if (resetButtonEl) {
        if (searchInput)
            inputEl.addEventListener(
                "input",
                handleSearchInput.bind(null, searchInput, "search-input--filled")
            );

        resetButtonEl.addEventListener("click", handleSearchReset.bind(null, inputEl));
    }
}
